/* eslint-disable import/no-anonymous-default-export */
import {Currency} from '@interface';
import {GameLogicInterface, GameRoomInterface} from 'poker-interfaces';
import {RestfulRoomInfo} from 'poker-interfaces/game-room/game-room-interface';
import {GameType} from 'poker-interfaces/gameLogic/gameLogicInterface';
import client from './index';
import {get} from 'js-cookie';

export default {
  async getCategoryList({
    currencyId,
    gameType,
    isAllIn,
    playerToken,
  }: {
    currencyId: string;
    gameType: string | string[];
    isAllIn: string;
    playerToken: string;
  }) {
    const res = await client.get('v2/play-room/category', {
      params: {
        currencyId,
        gameType,
        isAllIn,
      },
      headers: {
        'player-token': playerToken,
      },
    });
    const {categoryList} = res.data;
    return categoryList;
  },

  async getGameRecord({
    startDate,
    endDate,
    playerToken,
    page = 1,
    limit = 10,
  }: {
    startDate: string;
    endDate: string;
    playerToken: string;
    limit?: number;
    page?: number;
  }) {
    const paramList = {
      page,
      limit,
      startDate,
      endDate,
    };

    const res = await client.get(`v2/player/game-history`, {
      params: paramList,
      headers: {
        'player-token': playerToken,
      },
    });
    return res?.data;
  },

  async getOneGameRecord(id: number, playerToken: string) {
    const res = await client.get(`v2/player/game-history/${id}`, {
      headers: {
        'player-token': playerToken,
      },
    });
    return res.data;
  },

  async getTableRoomList({
    roomAmount,
    pageNumber,
    gameType,
    smallBlind,
    currencyId,
    isAllIn = false,
    playerToken,
  }: {
    roomAmount?: number;
    pageNumber?: number;
    gameType: string | string[];
    smallBlind: number;
    currencyId?: string;
    isAllIn: boolean;
    playerToken: string;
  }) {
    const response = await client.get(`v2/play-room/`, {
      params: {
        limit: roomAmount,
        page: pageNumber,
        filter: {
          gameType,
          smallBlind,
          currencyId,
          isAllIn,
        },
      },
      headers: {
        'player-token': playerToken,
      },
    });
    const tableRoomList = response.data.rows;
    return tableRoomList;
  },

  async getPlayRoomStats({
    currencyId,
    gameType,
    isAllIn = false,
    playerToken = null,
  }: {
    gameType: string | string[];
    currencyId?: string;
    isAllIn: boolean;
    playerToken?: string;
  }) {
    const response = await client.get('v2/play-room/room-stats', {
      params: {
        gameType,
        currencyId,
        isAllIn,
      },
      headers: {
        'player-token': playerToken,
      },
    });
    return response.data;
  },

  async getPlayerStats({
    currencyId,
    gameType,
    isAllIn = false,
    smallBlind,
    bigBlind,
    playerToken = null,
  }: {
    gameType: string | string[];
    currencyId?: string;
    isAllIn: boolean;
    smallBlind: number;
    bigBlind: number;
    playerToken?: string;
  }) {
    const response = await client.get('v2/play-room/player-stats', {
      params: {
        gameType,
        currencyId,
        isAllIn,
        smallBlind,
        bigBlind,
      },
      headers: {
        'player-token': playerToken,
      },
    });
    return response.data;
  },

  async getRandomRoom({
    gameType,
    smallBlind,
    bigBlind,
    playerToken,
    isAllIn,
    currencyId,
  }: {
    gameType: GameLogicInterface.GameType;
    smallBlind: number;
    bigBlind: number;
    playerToken: string;
    isAllIn: boolean;
    currencyId: Currency;
  }) {
    const res = await client.post(
      'v2/play-room/random',
      {
        gameType,
        smallBlind,
        bigBlind,
        isAllIn,
        currencyId: 'coin',
      },
      {
        headers: {
          'player-token': playerToken,
        },
      }
    );
    // console.log('res', res);
    return res.data;
  },

  // testing, seems impossible to filter by bigBlind
  async getRoomListByBigBlinds() {
    const response = await client.get(
      `v2/play-room/list?filter={"gameType":"REGULAR","bigBlind":6}`
    );
    const roomList = response.data.rows;
    return roomList;
  },

  async getRecentGames({
    roomCode,
    limit,
    page,
    playerToken,
  }: {
    roomCode: string | number;
    limit: number;
    page: number;
    playerToken: string;
  }) {
    const response = await client.get(`/v2/play-room/${roomCode}/recent-game`, {
      headers: {'player-token': playerToken},
      params: {
        limit,
        page,
      },
    });
    console.log('response', response);
    return response.data?.data?.rows;
  },

  async getHistoryDetail(gameId, playerToken: string) {
    const response = await client.get(`/v2/play-room/${gameId}/detail`, {
      headers: {'player-token': playerToken},
    });
    return response.data;
  },

  async getRakeCap({
    gameType,
    isAllIn,
    playerToken,
  }: {
    gameType: GameLogicInterface.GameType;
    isAllIn: boolean;
    playerToken: string;
  }) {
    const response = await client.get('/v2/rake-cap', {
      headers: {'player-token': playerToken},
      params: {gameType, isAllIn},
    });

    return response.data;
  },

  async createPrivateRoom(formValue: any, playerToken: string) {
    const response = await client.post('/v2/play-room/private', formValue, {
      headers: {'player-token': playerToken},
    });
    return response.data;
  },

  async getRoomPrice() {
    const response = await client.get('/v1/room-price');
    // console.log('response', response)
    return response.data;
  },

  async getGiftCategory(playerToken: string) {
    const response = await client.get(`/v2/player-gift/category`, {
      headers: {
        'player-token': playerToken,
      },
    });
    return response.data;
  },

  async getGiftRemark(
    playerToken: string,
    isCoinLoss?: boolean,
    roomType?: string,
    combination?: string
  ) {
    const response = await client.get(`v2/player-gift`, {
      params: {
        isCoinLoss,
        roomType,
        combination,
      },
      headers: {
        'player-token': playerToken,
      },
    });
    // console.log('*** response ***', response.data)
    return response.data;
  },

  async getWheelItem(wheelId: number) {
    const response = await client.get(`/v2/wheel/${wheelId}`);
    return response.data;
  },

  async redeemCode(playerToken: string, code: string) {
    const response = await client.post(`/v2/wheel/redeem-code/${code}`);
    return response.data;
  },

  async draw(playerToken: string, playerGiftId: number, uuid: string) {
    const response = await client.post(
      `/v2/wheel/draw`,
      {
        playerGiftId,
        uuid,
      },
      {
        headers: {
          'player-token': playerToken,
        },
      }
    );
    return response.data;
  },

  async getPlayerGiftHistory(playerToken: string) {
    const response = await client.get(`/v2/player-gift/player-gift-history`, {
      headers: {
        'player-token': playerToken,
      },
    });
    return response.data;
  },

  async getLuckyDrawInfo() {
    const response = await client.get(`/v3/lucky-draw`);
    return response.data;
  },

  async drawOnePrize(playerToken: string, wheelId: number) {
    const response = await client.post(
      `/v2/lucky-draw/draw-one`,
      {
        wheelId,
      },
      {
        headers: {
          'player-token': playerToken,
        },
      }
    );
    return response.data;
  },

  async getNumOfDraws(playerToken: string, wheelId: number) {
    const response = await client.get(`/v2/lucky-draw/available-draws/${wheelId}`, {
      headers: {
        'player-token': playerToken,
      },
    });
    return response.data;
  },

  async getRoomInfo(roomCode: string, playerToken: string): Promise<RestfulRoomInfo> {
    const response = await client.get(`/v2/play-room/getRoomInfo`, {
      params: {
        roomCode,
      },
      headers: {
        'player-token': playerToken,
      },
    });
    return response.data;
  },

  async getLeaderBoardInfo() {
    const response = await client.get('v2/player/leader-board');
    return response.data;
  },
};
